import { App } from '@capacitor/app'
import { Browser } from '@capacitor/browser'
import { Capacitor } from '@capacitor/core'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { needsAppUpdateForCheckout, parsePaymentReturnUrl } from './paymentDeepLink'

/**
 * Closes the in-app Stripe Checkout browser sheet and navigates back into the app when Stripe
 * redirects to our custom URL scheme (see usePaymentIntro / paymentDeepLink).
 */
export function usePaymentReturnListener() {
  const navigate = useNavigate()

  useEffect(() => {
    if (Capacitor.getPlatform() === 'web' || needsAppUpdateForCheckout()) return

    const listenerPromise = App.addListener('appUrlOpen', ({ url }) => {
      const targetPath = parsePaymentReturnUrl(url)
      if (!targetPath) return
      void Browser.close()
      navigate(targetPath, { replace: true })
    })

    return () => {
      void listenerPromise.then((listener) => listener.remove())
    }
  }, [navigate])
}
